import {
  red200, red300, red100, red700, red500, red,
  grey300, blue, blue700, blue500, blue400, blue50, blue600, blue300, cyan400,
  green700, green500, green100,
  white, darkBlack, fullBlack,
} from 'material-ui/styles/colors';
import {fade} from 'material-ui/utils/colorManipulator';
import spacing from 'material-ui/styles/spacing';

/**
 *  Light Theme is the default theme used in material-products. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */
export default {
  spacing,
  fontFamily: 'Roboto, sans-serif',
  borderRadius: 2,
  palette: {
    primary1Color: red500,
    primary2Color: red300,
    primary3Color: red100,
    accent1Color: green700,
    accent2Color: green500,
    accent3Color: green100,
    textColor: darkBlack,
    secondaryTextColor: fade(darkBlack, 0.54),
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: red200,
    clockCircleColor: fade(darkBlack, 0.07),
    shadowColor: fullBlack,
  },
};



// WEBPACK FOOTER //
// ./containers/themes/hungarianTheme.js